import type { IProgramList } from './ProgramList'

import { styled } from '@linaria/react'
import { ProgressLineBaseSC } from 'atoms/ProgressLine'
import { TVCardEPGSC } from 'blocks/Cards/TVCard'
import { TimeLineSC } from 'blocks/TimeLine'
import { COLOR } from 'vars/color'
import { CORNERS } from 'vars/corners'
import { MEDIA } from 'vars/media'

export const ChannelProgramRowSC = styled.div`
  overflow: hidden;
  width: 100%;
`

export const ChannelProgramListSC = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  max-width: 100%;
  overflow: auto;
  overflow-x: hidden;
`

export const ChannelProgramRowsSkeletonSC = styled.div`
  display: flex;
  flex-direction: column;
  gap: inherit;
  width: 100%;
`

export const ChannelProgramRowSkeletonSC = styled.div`
  display: inline-flex;
  gap: inherit;
  overflow: hidden;
  width: 100%;
`

export const ChannelProgramRowSkeletonBlockSC = styled.div<{
  variant?: 'channel' | 'program'
}>`
  height: var(--channelProgramRowHeight, 84px);
  border-radius: ${({ variant }) =>
    variant === 'program'
      ? `var(${CORNERS.CORNERS_25}) 0 0 var(${CORNERS.CORNERS_25})`
      : `var(${CORNERS.CORNERS_25})`};
  overflow: hidden;
  flex: ${({ variant }) =>
    variant === 'channel'
      ? '0 0 var(--channelProgramCardWidth, 84px)'
      : '0 0 var(--channelProgramAreaWidth, 100%)'};
  width: ${({ variant }) =>
    variant === 'channel'
      ? 'var(--channelProgramCardWidth, 84px)'
      : 'var(--channelProgramAreaWidth, 100%)'};
  min-width: ${({ variant }) =>
    variant === 'channel'
      ? 'var(--channelProgramCardWidth, 84px)'
      : 'var(--channelProgramAreaWidth, 100%)'};
  background:
    linear-gradient(
      to right,
      rgba(255, 255, 255, 0),
      rgba(190, 190, 190, 0.15) 50%,
      rgba(255, 255, 255, 0) 100%
    ),
    var(${COLOR.BACKGROUND_PROGRAM_CARD});
  background-repeat: repeat-y;
  background-size: 800px 850px;
  background-position: -800px 0;
  animation: channel-program-row-skeleton-shine 1.5s infinite;

  @keyframes channel-program-row-skeleton-shine {
    to {
      background-position: calc(100vw + 1200px) 0;
    }
  }
`

export const ProgramListSC = styled.div<
  Pick<
    IProgramList,
    'channelCardWidth' | 'tableGap' | 'channelCardHeight' | 'paddings'
  > & {
    progressPosition: number
    timeBlockWidth?: number
  }
>`
  --channelProgramCardWidth: ${({ channelCardHeight }) =>
    `${channelCardHeight}px`};
  --channelProgramRowHeight: ${({ channelCardHeight }) =>
    `${channelCardHeight}px`};
  --adaptiveWidthCard: ${({ channelCardHeight, tableGap }) =>
    `calc(${channelCardHeight}px + ${tableGap}px)`};
  --channelProgramAreaWidth: calc(
    100vw - var(--adaptiveWidthCard) - var(--scrollbar-width, 0px)
  );
  ${MEDIA.MIN_1240} {
    --channelProgramCardWidth: ${({ channelCardWidth }) =>
      `${channelCardWidth}px`};
    --adaptiveWidthCard: ${({ channelCardWidth, tableGap }) =>
      `calc(${channelCardWidth}px + ${tableGap}px)`};
  }
  display: flex;
  width: 100%;
  max-width: 100%;
  flex-direction: column;
  padding-bottom: ${({ tableGap }) => `${tableGap}px`};
  gap: ${({ tableGap }) => `${tableGap}px`};
  padding: ${({ paddings }) =>
    paddings && paddings.length > 0
      ? paddings.map((item) => `var(${item})`)?.join(' ')
      : 0};

  & ${ChannelProgramRowSC} {
    gap: ${({ tableGap }) => `${tableGap}px`};
    display: inline-flex;
  }

  & ${ChannelProgramListSC} {
    gap: ${({ tableGap }) => `${tableGap}px`};
  }

  & ${TimeLineSC} {
    --epg-card-width: var(--adaptiveWidthCard);
    ${MEDIA.MIN_1240} {
      --epg-card-width: var(--adaptiveWidthCard);
    }
  }

  & ${TVCardEPGSC} {
    width: ${({ channelCardHeight }) => channelCardHeight!}px;
    min-width: ${({ channelCardHeight }) => channelCardHeight!}px;
    height: ${({ channelCardHeight }) => channelCardHeight!}px;
    z-index: 2;
    ${MEDIA.MIN_1240} {
      width: ${({ channelCardWidth }) => channelCardWidth!}px;
      min-width: ${({ channelCardWidth }) => channelCardWidth!}px;
    }
  }

  & ${ProgressLineBaseSC} {
    left: ${({ tableGap, progressPosition, timeBlockWidth }) =>
      `clamp(calc(var(--adaptiveWidthCard) + ${tableGap}px - 79px), calc(${progressPosition}px - 80px), calc(var(--adaptiveWidthCard)  + ${tableGap}px  + ${timeBlockWidth}px - 80px))`};
  }
`
